/**
 * 设备标识相关工具函数
 */

/**
 * 生成设备唯一标识
 * 基于浏览器特征生成一个稳定的设备ID
 * @returns 设备ID字符串
 */
export function getDevice(): string {
  // 尝试从 localStorage 获取已存储的设备ID
  const stored = localStorage.getItem('device_id')
  if (stored) {
    return stored
  }

  // 收集浏览器特征
  const features = [
    navigator.userAgent,
    navigator.language,
    screen.width + 'x' + screen.height,
    screen.colorDepth,
    new Date().getTimezoneOffset(),
  ]

  // 生成设备指纹
  const fingerprint = features.join('|')
  //   const deviceId = hashCode(fingerprint).toString(36)

  // 存储到 localStorage
  localStorage.setItem('device_id', fingerprint)

  return fingerprint
}

/**
 * 简单的字符串哈希函数
 * @param str 输入字符串
 * @returns 哈希值
 */
function hashCode(str: string): number {
  let hash = 0
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash // Convert to 32bit integer
  }
  return Math.abs(hash)
}
